import { render, staticRenderFns } from "./SkillAnswers.vue?vue&type=template&id=68bfb73c&scoped=true"
import script from "./SkillAnswers.vue?vue&type=script&lang=js"
export * from "./SkillAnswers.vue?vue&type=script&lang=js"
import style0 from "./SkillAnswers.vue?vue&type=style&index=0&id=68bfb73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfb73c",
  null
  
)

export default component.exports